import { render, staticRenderFns } from "./PageEmployeeCompliance.vue?vue&type=template&id=7094fc3e&"
import script from "./PageEmployeeCompliance.vue?vue&type=script&lang=js&"
export * from "./PageEmployeeCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports